import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer, getError } from '../../../../../../helpers/reducer';
import { keyBy } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

const initState = {
  editForm: null,
  baseError: null,
  loading: false,
  total: 0,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'started_at') {
    if (isEmpty(value)) {
      error = t('dash.validation.choose_a_field', { fieldName: t('dash.jobs.bookings.start_date') });
    }
  }

  if (attr === 'finished_at') {
    if (isEmpty(value)) {
      error = t('dash.validation.choose_a_field', { fieldName: t('dash.jobs.bookings.end_date') });
    }
  }

  return error;
}

function onLoad(state, { payload }) {
  return {
    ...state,
    loading: false,
    editForm: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

function onSaveSuccess(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        error: getError(entry[0], data),
        touched: true,
      };
    },
  );

  const baseError = data.base ? data.base[0] : null;

  return {
    ...state,
    editForm,
    baseError,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  const baseError = null;

  return {
    ...state,
    editForm: {
      ...editForm,
    },
    baseError,
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CANCEL]: onCancel,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.TOUCH]: onTouch,
});
